import axios from 'axios'
import store from '@store'
import { messageError } from "@utils/message";
import { Trans } from "@utils/translation";
import router from "@router/index";
import Vue from "vue";
import { MessageBox } from 'element-ui';

axios.defaults.baseURL = '/api';

// console.log('API_PATH:', axios.defaults.baseURL);
axios.interceptors.request.use(
  (config) => {
    const configName = config?.name || 'api';
    Vue.prototype.$startLoading(configName);

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
);

axios.interceptors.response.use((response) => {
  setTimeout(() => {
    Vue.prototype.$endLoading(response.config.name || 'api');
  }, response.config.endLoadingDelay || 0);
  // return Promise.reject(response)
  return response.data?.data || response.data
}, errorResponseHandler);

function errorResponseHandler(error) {
  // check fro errorHandle config
  const {
    config,
    response
  } = error;

  Vue.prototype.$endLoading(config?.name || 'api');

  if(response) {
    if(config.hasOwnProperty('customErrorHandle')) {
      config.customErrorHandle(response.data);

      return Promise.reject(response.data);
    }

    // axios v0.19.0 custom config 會被忽略
    /* if(config.hasOwnProperty('errorHandle') && config.errorHandle === false) {
      return response.data
    } */

    if(!config.errorHandle) {
      return response.data
    }

    if(config.showMessage) {
      if(response.data.status.indexOf('INPUT_INVALID') !== -1 || response.data.status.indexOf('INVALID_INPUT') !== -1) {
        const content = () => {
          const level1 = Object.keys(response.data.data.items);

          let level1Content = '';

          level1.forEach(level1Key => {
            const level2 = response.data.data.items[level1Key];

            const level2Content = () => {
              let level2Content = '';

              if(level2.length > 0) {
                level2.forEach(level2Text => {
                  level2Content += `<li>${ level2Text }</li>`
                });

                return `<ul>${ level2Content }</ul>`
              } else {
                return ''
              }
            };

            level1Content += `<li>${ level1Key }${ level2Content() }</li>`
          });

          return `<ol>${ level1Content }</ol>`
        };

        MessageBox.alert(content(), '欄位錯誤', {
          customClass: 'isStyleError',
          confirmButtonText: '確定',
          dangerouslyUseHTMLString: true
        })
      } else {

        messageError({
          title: '錯誤',
          content: response.data?.message || '',
          duration: 3000,
        });
      }
    };

    // 405 Method Not Allowed
    if(config.logoutRedirect && (response.data.code === 405 || response.data.code === 401)) {
      store.dispatch('auth/logOut')
        .then(() => {
          router.push({
            name: 'login',
            query: {
              redirectFrom: location.pathname
            },
            params: {
              lang: Trans.getUserSupportedLang()
            }
          })
        });
    }

    return Promise.reject(response.data)
  } else if(!window.navigator.onLine) {
    messageError('網路出了點問題，請重新連線後刷新頁面');
  } else {
    return Promise.reject(error)
  }
}

export default axios
